// src/guards/RequireProviderAgreement.jsx
import { useQuery } from "@apollo/client";
import { Navigate, useLocation } from "react-router-dom";
import { GET_PROVIDER_AGREEMENT_STATUS } from "../graphql/queries/care";

const PENDING_KEY = "pendingClaim";

export default function RequireProviderAgreement({ businessId, children }) {
  const loc = useLocation();
  const hasPendingClaim = typeof window !== "undefined" && !!sessionStorage.getItem(PENDING_KEY);

  const { data, loading } = useQuery(GET_PROVIDER_AGREEMENT_STATUS, {
    variables: { businessId: Number(businessId) },
    skip: !businessId,
    fetchPolicy: "cache-first",
  });

  // If there's no business yet but we have a pending claim, finish it first.
  if (!businessId) {
    if (hasPendingClaim) {
      return <Navigate to="/care/claim-resume" replace />;
    }
    return <Navigate to="/biz/business" replace />;
  }

  if (loading) return null;

  const needs = data?.getProviderAgreementStatus?.needsAcceptance ?? true;
  if (needs) {
    return (
      <Navigate
        to={`/care/agreement?businessId=${businessId}`}
        state={{ from: loc.pathname }}
        replace
      />
    );
  }
  return children;
}
